/* src/components/Sidebar.js - v5.2 - Guest Logic Fixed */
import React from 'react';
import MENU_ITEMS from '../menuConfig.json'; 

function Sidebar({ onNavigate, onRefresh, onLogout, user, messageCount, onSearch }) {
  
  const handleNavClick = (view) => {
    onNavigate(view);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const iconStyle = {
    width: '45px', height: '45px', objectFit: 'cover',
    borderRadius: '50%', display: 'block',
    boxShadow: '0 4px 6px rgba(0,0,0,0.3)'
  };

  // --- LOGIC UPDATE: GUEST VS USER ---
  let activeLayout;

  if (!user || user.isGuest) {
      // GUEST MODE: Match the bottom menubar (Home, Groups, Search)
      activeLayout = ['home', 'groups', 'search'];
  } else {
      // USER MODE: Use their custom layout or default to full list
      activeLayout = user.menu_layout || MENU_ITEMS.map(i => i.id);
      
      // Ensure mandatory items exist for logged-in users
      if (!activeLayout.includes('profile')) activeLayout = ['profile', ...activeLayout];
      if (!activeLayout.includes('home')) activeLayout = [...activeLayout, 'home'];
  }

  const renderMenuItem = (id) => {
      const item = MENU_ITEMS.find(i => i.id === id);
      if (!item) return null;

      let content = null;
      let onClick = () => {};
      let badge = null;

      switch(id) {
          case 'profile':
              // Double check: Guests should never see profile icon in sidebar
              if (!user || user.isGuest) return null;
              
              onClick = () => handleNavClick('profile');
              content = user.profile_pic ? (
                  <img src={user.profile_pic} alt="Profile" className="sidebar-img" style={iconStyle} />
              ) : (
                  <div className="sidebar-placeholder" style={{ ...iconStyle, backgroundColor: user.avatarColor, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 'bold', fontSize: '1.2rem' }}>
                      {user.name[0].toUpperCase()}
                  </div>
              );
              break;
          case 'home':
              onClick = onRefresh;
              content = (
                  <img 
                    src="/newsfeed.png" 
                    alt="Nubix" 
                    className="sidebar-img"
                    style={{ width: '26px', height: '26px', objectFit: 'cover', display: 'block' }}
                    onClick={(e) => { e.stopPropagation(); onRefresh(); }} 
                  />
              );
              break;
          case 'messages':
              onClick = () => handleNavClick('messages');
              content = <span style={{ fontSize: '26px' }}>{item.icon}</span>;
              if (messageCount > 0) badge = <span className="nav-badge">{messageCount}</span>;
              break;
          case 'groups':
              onClick = () => handleNavClick('groups');
              content = <span style={{ fontSize: '26px' }}>{item.icon}</span>;
              break;
          case 'nexus':
              onClick = () => handleNavClick('nexus');
              content = <span style={{ fontSize: '26px' }}>{item.icon}</span>;
              break;
          case 'search':
              onClick = () => onSearch(true);
              content = <span style={{ fontSize: '26px' }}>{item.icon}</span>;
              break;
          default:
              return null;
      }

      return (
          <button key={id} className="nav-btn" onClick={onClick} title={item.label} style={{ background: 'transparent', border: 'none', padding: '0', cursor: 'pointer', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {content}
            {badge}
          </button>
      );
  };

  return (
    <div className="sidebar">
      {/* Fixed layout (500px height) preserved */}
      <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          height: '500px',        
          width: '100%',
          padding: '15px 0'
      }}>
          {activeLayout.map(id => renderMenuItem(id))}
      </div>
    </div>
  );
}

export default Sidebar;
